export default __webpack_public_path__ + "maps-examples-point-conversion-thumbnail-480-bb072ed52632e5e4ec564c1dfb253648.webp";